import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-credits-info',
  templateUrl: './credits-info.component.html',
  styleUrls: ['./credits-info.component.scss']
})
export class CreditsInfoComponent {

  @Input() title: string = '';
  @Input() description: string = '';
  @Input() subText: string = '';

}
